import React from 'react';
import { Typography, Card, List } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  const terms = [
    t('legal.terms_intro'),
    t('common.not_found', {
      defaultValue:
        'Use of this site must comply with applicable laws and respect intellectual property.',
    }),
    t('common.not_found', {
      defaultValue:
        'Content is provided for reference only and may change without notice.',
    }),
  ];

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <Title level={1}>{t('legal.terms_title')}</Title>
      <Card style={{ marginTop: 16 }}>
        <List
          size="small"
          dataSource={terms}
          renderItem={item => (
            <List.Item>
              <Text type="secondary">{item}</Text>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default TermsPage;
